import z from "zod";
import {zodRequiredPriceSchema} from "./zodRequiredPriceSchema";

// Either it passes no value at all (undefined) or it passes a fully valid price object
export const zodOptionalPriceSchema = z
.preprocess((val) => {
    const price = val as { currency?: string; value?: number } | undefined;

    // If either currency or price value is not provided,
    // mark the field as undefined to allow it to be optional
    if (!price?.currency || price.value === undefined) {
        return undefined;
    }

    return price;
}, zodRequiredPriceSchema.optional());
